import {CellTitleDefaultBox} from './cell-title.default.box';

export const CellTitleBox = CellTitleDefaultBox;